import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=0276a70c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=0276a70c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0276a70c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0276a70c')) {
      api.createRecord('0276a70c', component.options)
    } else {
      api.reload('0276a70c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=0276a70c&scoped=true&", function () {
      api.rerender('0276a70c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B6wGS5YGi759/JS/comp/PopupBox.vue"
export default component.exports